import { render } from "./_fund-change-modal.vue?vue&type=template&id=b6b11b22"
import script from "./_fund-change-modal.vue?vue&type=script&lang=js"
export * from "./_fund-change-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__